
$(document).ready(function() {
    /* Validate Login */
    $('#customer_login').validate({
        errorElement: "em",
        errorPlacement: function ( error, element ) {
            // Add the `invalid-feedback` class to the error element
            error.addClass( "invalid-feedback" );

            if ( element.prop( "type" ) === "checkbox" ) {
                error.insertAfter( element.next( "label" ) );
            } else {
                error.insertAfter( element );
            }
        },
        highlight: function ( element, errorClass, validClass ) {
            $( element ).addClass( "is-invalid" ).removeClass( "is-valid" );
        },
        unhighlight: function (element, errorClass, validClass) {
            $( element ).addClass( "is-valid" ).removeClass( "is-invalid" );
        }
    });


    $('.qtybox .btnqty').on('click', function(e) {
        e.preventDefault();
        var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
        if ($(this).hasClass('qtyplus')) {
            qty++;
        } else {
            if (qty > 1) {
                qty--;
            }
        }
        qty = (isNaN(qty)) ? 1 : qty;
        $(this).parent('.qtybox').find('.quantity-input').val(qty);
    });

    $('button.btn-blue').click(function(){
        window.location.href = "/account/register";
    });

    $('button.btn-white').click(function(){
        window.location.href = "/";
    });

});

$(document).ready(function() {async function updateLineItem(data) {
        await fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then( async function(cart) {
              
                let itemKey = data.itemKey;
                let bcldbSku = data.bcldbSku;
                let gramsValue = data.gramsValue
                let lineItem = cart.items.filter(i => i.key == itemKey);

                let itemData = {
                    'id': itemKey,
                    'quantity': lineItem[0].quantity,
                    'properties': {
                        "BCLDB SKU": bcldbSku,
                        "Dried flower equivalent": gramsValue,
                    }
                };
                await fetch(
                    window.Shopify.routes.root + 'cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(itemData)

                    }).then(response => {
                    return data;
                }).catch((error) => {
                    console.error('Error:', error);
                });
            })
    }

    async function getItemMetaFieldValue(data) {
      
        let productId = "gid://shopify/Product/" + data.productId;
        let variantId = btoa("gid://shopify/ProductVariant/" + data.variantId);
        let isSimple = data.isSimple;
        let itemKey = data.itemKey;
        let productQuery;
        if (isSimple === true) {
            productQuery = () => `query {
            product(id: "${productId}") {
                id
                bcldb_sku: metafield(namespace: "custom", key: "bcldb_sku") {
                    value
                }
                grams_value: metafield(namespace: "custom", key: "grams_value") {
                    value
                }
            }
        }`;
        } else {
            productQuery = () => `
                query {
                  node(id:  "${variantId}") {
                    ... on ProductVariant {
                        id
                        bcldb_sku: metafield(namespace: "custom", key: "bcldb_sku") {
                            value
                        }
                        grams_value: metafield(namespace: "custom", key: "grams_value") {
                            value
                        }
                    }
                  }
                }
                `;
        }
        await fetch('/api/2024-04/graphql.json', {
            method: 'POST',
            headers: {
                'X-Shopify-Storefront-Access-Token': 'fe919c4c60552585e6e6e2529b6f705b',
                'Content-Type': 'application/graphql'
            },
            body: productQuery()
        })
            .then(response => response.json())
            .then( async function(res) {
                if (res.data) {
                    let bcldbSku = 0;
                    let gramsValue = 0;

                    if (isSimple === true) {
                        if (res.data.product.bcldb_sku !== null) {
                            if (res.data.product.bcldb_sku.value !== null) {
                                bcldbSku = res.data.product.bcldb_sku.value;
                            }
                        }
                        if (res.data.product.grams_value !== null) {
                            if (res.data.product.grams_value.value !== null) {
                                gramsValue = res.data.product.grams_value.value;
                            }
                        }
                    } else {
                        if (res.data.node !== null) {
                            if (res.data.node.bcldb_sku !== null) {
                                if (res.data.node.bcldb_sku.value !== null) {
                                    bcldbSku = res.data.node.bcldb_sku.value;
                                }
                            }
                            if (res.data.node.grams_value !== null) {
                                if (res.data.node.grams_value.value !== null) {
                                    gramsValue = res.data.node.grams_value.value;
                                }
                            }
                        }
                    }

                    const data = {
                        itemKey: itemKey,
                        bcldbSku: bcldbSku,
                        gramsValue: gramsValue
                    };

                    return data
                }
            })
            .then((data) => updateLineItem(data))
            .catch(err => console.error(err));
    }


    async function refreshMetaFields() {
        fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then( async function(data) {
              
                let cart_items = data.items
                for await (const element of cart_items) {
                    let alreadyChecked = false;
                    if (element.properties != null && element.properties['BCLDB SKU'] != null) {
                        alreadyChecked = true;
                    }
                    if (alreadyChecked === false) {
                        const pData = {
                            productId: element.product_id,
                            variantId: element.variant_id,
                            itemKey: element.key,
                            isSimple: element.product_has_only_default_variant
                        };
                        const metaData = await getItemMetaFieldValue(pData)
                    }

                }
                return cart_items.length
            })
            .then(function(data) {
                
                checkoutButton.innerHTML = 'Check out'
                checkoutButton.disabled = false;
                checkoutButton.style.display = "inline-block";
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    var checkoutButton = document.getElementById('checkout');
    if (checkoutButton) {
        checkoutButton.style.display = "inline-block";
        checkoutButton.disabled = true;
        var waitMsg = '<i class="fa fa-spinner fa-spin"></i> Please Wait...';
        checkoutButton.innerHTML = waitMsg;
        refreshMetaFields();
    }

    document.addEventListener("variantChange", function(event) {
        let variantID = event.detail.variant.id;
        let productData = document.querySelector("[data-variant-id='" + CSS.escape(variantID) + "'][data-option-id]");
        if (productData) {
            let productDataGramsValue = productData.getAttribute('data-variant-grams-value');
            let productDataBcldbSku = productData.getAttribute('data-variant-bcldb_sku');
            $('#current-variant-grams-value').val(productDataGramsValue);
            $('#current-variant-bcldb_sku').val(productDataBcldbSku);
        }
    });
  
});



$(document).ready(function() {
  
      window.addEventListener("globoFilterCloseSearchCompleted", function(event) {
            document.querySelector('nav.mobile-nav-wrapper').classList.remove('is-transitioning');
            $(".search-bar__close.js-drawer-close").trigger("click");
      });
  
});



